export default {
    path: 'services',
    name: 'ServiceForm',
    component() {
        return import('@/components/service/ServiceForm.vue')
    },
    children: [
        {
            path: '',
            name: 'ServiceOnCampusPropagateList',
            component() {
                return import('@/components/service/serviceOnCampusPropagate/ServiceOnCampusPropagateList.vue')
            },
        },
        {
            path: 'general',
            name: 'ServiceOnCampusGeneralList',
            component() {
                return import('@/components/service/serviceOnCampusGeneral/ServiceOnCampusGeneralList')
            },
        },
        {
            path: 'general/:id',
            name: 'ServiceOnCampusGeneralDetail',
            component() {
                return import('@/components/service/serviceOnCampusGeneral/ServiceOnCampusGeneralDetail.vue')
            },
        },
        {
            path: 'off',
            name: 'ServiceOffCampusList',
            component() {
                return import('@/components/service/serviceOffCampus/ServiceOffCampusList')
            },
        },
        {
            path: 'off/:id',
            name: 'ServiceOffCampusDetail',
            component() {
                return import('@/components/service/serviceOffCampus/ServiceOffCampusDetail.vue')
            },
        },
    ],
}